<template>
  <popover-right v-model="isShowGenerate" width='775px' :closed="cancel" class="task-detail-self" :isShowAll="false">
    <div class="task-detail-self-1">
      <div class="details">
        <h1 class="name">
          <el-checkbox class="el-task-checkbox" v-model="status_checked" :disabled="!((info.is_allow_completed && info.handle_status === 1) || (info.is_allow_pending && info.handle_status === 2))" @change="changeCompelete"></el-checkbox>
          {{info.title || '--'}}
          <span :class="'level level-' + info.level">{{info.level_name || '--'}}</span>
        </h1>
        <p class="times">
          <span>创建人：{{info.creator_name || '--'}}</span>
          <span>创建于：{{info.created_at || '--'}}</span>
        </p>
        <p class="descs">{{info.description || '--'}}</p>
        <div class="clearfix end-times">
          <p class="floatL">截止日期：{{dealEnd}}</p>
          <p class="floatR" v-if="info.handle_status === 2">完成日期：{{handleTime}}</p>
          <p class="floatR" v-if="info.handle_status === 4">取消日期：{{handleTime}}</p>
        </div>
        <el-button type="primary" class="cancel-btn" v-if="info.is_allow_cancel" @click="removeTask">取消任务</el-button>
      </div>
      <div class="excute-detail">
        <template v-if="info.ext_data && info.ext_data.length > 0">
          <h1 class="title">执行情况（完成率{{percent}}%）</h1>
          <div class="excute-bar">
            <div class="bar">
              <p class="active" :style="{width: percent + '%'}"></p>
            </div>
            <span class="bar-label">{{info.ext_completed_total || 0}}/{{info.ext_total || 0}}</span>
          </div>
          <el-table class="excute-table" header-align="center" align="center" :data="info.ext_data">
            <el-table-column label="参与人">
              <template slot-scope="scope">
                <el-popover placement="bottom-end" width="200" trigger="hover" popper-class="popover-user-info" @show="getAdminDetail(scope.row.to_admin_id)">
                  <div v-if="userData[scope.row.to_admin_id]">
                    <h1 class="popover-name popover-name-portia">
                      <img class="portia" 
                        :src="!userData[scope.row.to_admin_id].avatar ? require('@/assets/images/default-admin.png') : `${defaultSetting.sourceUrl}${userData[scope.row.to_admin_id].avatar}`" />
                      {{userData[scope.row.to_admin_id].name || '--'}}
                    </h1>
                    <div class="user-desc">
                      <div class="popover-user-desc">
                        <span>部门：</span>
                        <p>{{userData[scope.row.to_admin_id].dept_name || '--'}}</p>
                      </div>
                      <div class="popover-user-desc">
                        <span>角色：</span>
                        <p>{{userData[scope.row.to_admin_id].role_name || '--'}}</p>
                      </div>
                      <div class="popover-user-desc">
                        <span>手机：</span>
                        <p>{{userData[scope.row.to_admin_id].mobile || '--'}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="user-none" v-else>
                    <i class="el-icon-loading"></i>
                    <p>正在加载中</p>
                  </div>
                  <div>
                  </div>
                  <p slot="reference">{{scope.row.to_admin_name || '--'}}</p>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column label="完成情况" prop="handle_status_name"></el-table-column>
            <el-table-column label="完成日期">
              <template slot-scope="scope">
                <span v-analysis-time="scope.row.handle_time"></span>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
    </div>
  </popover-right>
</template>
<script>
import PopoverRight from '@/components/popover/index';
import {getTaskGeneral, setTaskStatus, getAdminInfo,editTaskCompelete} from '@/api/task';
import defaultSetting from '@/setting/index';
export default {
  name: 'TaskGeneral',
  components: {
    PopoverRight
  },
  props: {
    value: String,
    taskId: Number,
    callback: Function
  },
  computed: {
    isShowGenerate () {
      return this.value === 'taskGeneral';
    },
    dealEnd () {
      if (!this.info.deadline || this.info.deadline === 0) return '';
      const date = new Date(this.info.deadline * 1000);
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    handleTime () {
      if (!this.info.handle_time || this.info.handle_time === 0) return '';
      const date = new Date(this.info.handle_time * 1000);
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    percent () {
      const actual = this.info.ext_completed_total || 0;
      const total = this.info.ext_total || 0;
      return Math.floor(actual / total * 100);
    }
  },
  data () {
    return {
      info: {},
      userData: {},
      status_checked: false,
      defaultSetting: defaultSetting
    }
  },
  created () {
    this.initDetail();
  },
  methods: {
    /** 更改完成状态 */
    async changeCompelete (status){
      try {
        await editTaskCompelete({
          id: this.taskId,
          handle_status: status ? 2 : 1
        });
        this.$message.success('操作成功');
        this.initDetail();
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    },
    cancel () {
      this.$emit('input', false);
      this.info = {};
    },
    async initDetail () {
      try {
        const res = await getTaskGeneral(this.taskId);
        this.info = res;
        this.status_checked = res.handle_status === 2;
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    },
    async removeTask () {
      try {
        await setTaskStatus({
          id: this.taskId,
          handle_status: 4
        });
        this.$message.success('取消成功');
        this.callback && this.callback();
        this.cancel();
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    },
    /** 请求经纪人详情 */
    async getAdminDetail (id){
      if (!id) return null;
      if (this.userData[id]) return null;
      try {
        const res = await getAdminInfo(id);
        this.$set(this.userData, id, res);
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    },
  }
}
</script>
<style lang="less">
.el-checkbox.el-task-checkbox{
  margin-left: -30px;
  margin-right: 10px;
}
</style>